/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InquiryDto } from '../../models/inquiry-dto';
import { UpdateInquiryStatusDto } from '../../models/update-inquiry-status-dto';

export interface InquiryControllerUpdateStatusV1$Params {
  id: string;
      body: UpdateInquiryStatusDto
}

export function inquiryControllerUpdateStatusV1(http: HttpClient, rootUrl: string, params: InquiryControllerUpdateStatusV1$Params, context?: HttpContext): Observable<StrictHttpResponse<InquiryDto>> {
  const rb = new RequestBuilder(rootUrl, inquiryControllerUpdateStatusV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InquiryDto>;
    })
  );
}

inquiryControllerUpdateStatusV1.PATH = '/api/v1/inquiry/{id}/status';
